
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  KycPartner,
  ValidationError,
} from '../models';
import {
    KycPartnerFromJSON,
    KycPartnerToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface ValidateDocumentsWithPartnerRequest {
    companyId: string;
    externalId: string;
    partner: KycPartner;
}

export interface VerifyKycWithPartnerRequest {
    companyId: string;
    partner?: KycPartner;
}

/**
 * 
 */
export class KycSimulationApi extends runtime.BaseAPI {

    /**
     * Validate specific documents with a partner. The partner parameter is optional.
     * Validate documents with a partner
          */
    async validateDocumentsWithPartnerRaw(requestParameters: ValidateDocumentsWithPartnerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling validateDocumentsWithPartner().'
            );
        }

        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling validateDocumentsWithPartner().'
            );
        }

        if (requestParameters['partner'] == null) {
            throw new runtime.RequiredError(
                'partner',
                'Required parameter "partner" was null or undefined when calling validateDocumentsWithPartner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['externalId'] != null) {
            queryParameters['externalId'] = requestParameters['externalId'];
        }

        if (requestParameters['partner'] != null) {
            queryParameters['partner'] = requestParameters['partner'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/documents/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Validate specific documents with a partner. The partner parameter is optional.
     * Validate documents with a partner
          */
    async validateDocumentsWithPartner(requestParameters: ValidateDocumentsWithPartnerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.validateDocumentsWithPartnerRaw(requestParameters, initOverrides);
    }

    /**
     * Simulate the KYC (Know Your Customer) process with a specific partner. This endpoint is only accessible in integration environment.
     * Simulate KYC process with a partner
          */
    async verifyKycWithPartnerRaw(requestParameters: VerifyKycWithPartnerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling verifyKycWithPartner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['partner'] != null) {
            queryParameters['partner'] = requestParameters['partner'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/kyc/simulate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Simulate the KYC (Know Your Customer) process with a specific partner. This endpoint is only accessible in integration environment.
     * Simulate KYC process with a partner
          */
    async verifyKycWithPartner(requestParameters: VerifyKycWithPartnerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyKycWithPartnerRaw(requestParameters, initOverrides);
    }

}
